import React from 'react';

export function ManualPaymentNotice() {
    return (
        <p className="text-muted mb-3">
            <strong>We do not automatically process payments with PayPal.</strong> We encourage customers who want to
            automatically pay invoices from PayPal to deposit sufficient credit to cover their expected costs.
            Alternatively, you can pay each invoice via PayPal using the link displayed in the invoice list.
        </p>
    );
}
